import { render, staticRenderFns } from "./order_detail.vue?vue&type=template&id=29aed78f&scoped=true&"
import script from "./order_detail.vue?vue&type=script&lang=js&"
export * from "./order_detail.vue?vue&type=script&lang=js&"
import style0 from "./order_detail.vue?vue&type=style&index=0&id=29aed78f&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29aed78f",
  null
  
)

export default component.exports